export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const MAX_USE_LIMIT = 90;

export const POSITIVE_NUMBER_PATTERN = /^[1-9][0-9]*$/;

export const FUNDING_CYCLE_STEPS = [
  {
    key: 1,
    nameKey: "ovo_admin_heading_setup_new_cycle_funding_limit",
    isFirstStep: true,
    isLastStep: false,
    componentNameKey: "setupLimit",
    componentTitleKey: "ovo_admin_heading_setup_new_cycle_funding_limit",
  },
  {
    key: 2,
    nameKey: "ovo_admin_heading_setup_choose_lenders_funding_limit",
    isFirstStep: false,
    isLastStep: false,
    componentNameKey: "productLenderMapping",
    componentTitleKey: "ovo_admin_heading_setup_choose_lenders_funding_limit",
  },
  {
    key: 3,
    nameKey: "ovo_admin_heading_setup_rank_lenders_funding_limit",
    isFirstStep: false,
    isLastStep: false,
    componentNameKey: "lenderRanking",
    componentTitleKey: "ovo_admin_heading_setup_rank_lenders_funding_limit",
  },
  {
    key: 4,
    nameKey: "ovo_admin_heading_setup_select_date_funding_limit",
    isFirstStep: false,
    isLastStep: true,
    componentNameKey: "selectDate",
    componentTitleKey: "ovo_admin_heading_setup_select_date_funding_limit",
  }
];

export const ACTION_MAPPING = {
  saveProductLimit: "saveProductLimit",
  saveLenderRank: "saveLenderRank",
  saveLimit: "saveLimit",
  saveProductLenderMap: "saveProductLenderMap",
  editLenderRanking: "editLenderRanking",
  fetchingData: "fetchingData",
  saveScheduleDate: "saveScheduleDate",
};

export const SHOW_LENDER_RANKING_VIEW_FLAG = "showLenderRankingView";
export const SHOW_NEW_CYCLE_VIEW_FLAG = "showNewCycleView";

export const EMPTY_STRING = "";

export const VALIDATION_ERROR_MESSAGE_KEYS = {
  requiredField: "errorMessages.requiredField",
};

export const DEFAULT_LENDER_OBJECT = {
  lender_id: "",
  lender_name: "",
  balance: 0,
  lender_limit_snapshot: -1,
  can_fund: false,
  rank: -1,
};

export const DEFAULT_PRODUCT_CODE = "invoice-financing";
export const FALLBACK_PRODUCT_CODE = "OMU";
export const LIMIT_PLACEHOLDER = "Rp 1.000.000";
export const LENDER_RANK_PLACEHOLDER = "1";

export const DEFAULT_FUNDING_LIMIT_INPUT_AMOUNT_OBJECT = {
  inputAmount: '',
  isCurrentInputAmountInvalid: false,
  currentInvalidInputAmountMessage: ''
}

export const SUCCESS_STATUS = "success";